var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _rect, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaterPlant = function SvgWaterPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147,
    height: 107,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    strokeWidth: 2,
    d: "M33.071 51.32c-3.531-6.563-11.49-9.436-18.554-6.666 3.518 6.538 11.453 9.424 18.554 6.666ZM36.44 51.014c2.369-7.099 9.72-11.362 17.144-9.907-2.36 7.071-9.685 11.343-17.144 9.907ZM31.977 40.266c-2.9-5.183-9.22-7.465-14.887-5.345 2.89 5.164 9.19 7.456 14.887 5.345ZM35.24 39.972c1.98-5.627 7.817-9.013 13.755-7.946-1.972 5.605-7.79 8.998-13.756 7.945ZM31.28 31.516c-2.283-3.847-7.017-5.557-11.326-4.063 2.275 3.833 6.996 5.55 11.327 4.063ZM34.456 31.228c1.598-4.2 5.97-6.736 10.466-6.041-1.592 4.184-5.95 6.726-10.466 6.041ZM30.668 24.025c-1.74-2.69-5.1-3.904-8.225-2.947 1.733 2.68 5.085 3.9 8.225 2.947ZM33.79 23.743c1.258-2.963 4.363-4.763 7.601-4.384-1.253 2.95-4.348 4.756-7.6 4.384ZM30.651 18.729c-.87-3.097-3.722-5.267-6.98-5.293.867 3.085 3.708 5.258 6.98 5.293ZM32.972 16.502c-.258-3.211 1.656-6.273 4.695-7.477.258 3.2-1.646 6.26-4.695 7.477Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#169B62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33.012 16.403c-1.305.555-.598 27.518 7.263 70.726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M56.184 57.354H12.6V73.54h43.584z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.753,
    cy: 17.395,
    fill: "#C3C3C3",
    rx: 21.753,
    ry: 17.395,
    transform: "matrix(-1 0 0 1 56.105 57.354)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    d: "M136.547 69.83c-5.196 5.921-21.508 15.344-25.806 9.467-5.741-4.429.04-21.024 5.236-26.946 5.196-5.921 14.063-7.131 19.804-2.703 5.742 4.429 5.963 14.26.766 20.182"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.351 67.362c-3.91 4.454-15.262 11.538-19.582 8.206-4.319-3.331.031-15.817 3.94-20.272s10.58-5.365 14.899-2.033 4.652 9.644.743 14.099"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M59.289 49.798 82.94 69.007l-3.854 12.055c-10.2-3.252-18.595-17.217-25.573-25.649l2.975-2.995z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.447,
    height: 42.827,
    x: 0.486,
    y: 0.509,
    fill: "#125A42",
    stroke: "#125A42",
    rx: 1,
    transform: "matrix(1.02838 .05101 -.05636 .96762 78.502 42.917)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    strokeLinecap: "round",
    d: "m49.453 53.989 3.651 1.268a.11.11 0 0 0 .105-.02l6.133-5.282a.1.1 0 0 0 .028-.11l-1.428-3.526a.1.1 0 0 0-.123-.055c-3.64 1.145-7.475 5.04-8.425 7.606-.018.05.008.101.059.119Z"
  })));
};
export { SvgWaterPlant as ReactComponent };
export default __webpack_public_path__ + "images/water-plant.svg";